import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);
const router = new Router({
    routes: [{
        path: '/',
        name: 'home',
        component: () => import("@/layout/home.vue"),
        children: [
            {
                path: '/',
                name: 'index',
                component: () => import("@/views/index/index.vue")
            },
            {
                path: '/about',
                name: 'about',
                component: () => import("@/views/about/index.vue")
            },
            {
                path: '/news',
                name: 'news',
                component: () => import("@/views/news/index.vue")
            },
            {
                path: '/details',
                name: 'details',
                component: () => import("@/views/newsDetails/index.vue")
            },
            {
                path: '/case',
                name: 'case',
                component: () => import("@/views/case/index.vue")
            },
            {
                path: '/product',
                name: 'product',
                component: () => import("@/views/product/index.vue")
            }

        ]
    }],
    scrollBehavior() {
        // return 期望滚动到哪个的位置
        return {
            y: 0,
        };
    },
});
export default router;